export default __webpack_public_path__ + "static/blog-header-f936c2102906494be9fe93c8fd3d6756.jpg";